import * as React from 'react';
import { FormControl, FormHelperText, FormLabel, TextField } from '@mui/material';
import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import { Listbox } from '@features/effector-form/components/listbox';
import { withControl } from '@features/effector-form/hoc/withControl';
import i18n from '@shared/config/i18n';

const { t } = i18n;

export const ResidentStatusControl = withControl<
  Partial<AutocompleteProps<any, any, any, any>>
>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    multiple,
    isError,
  }) => {
    const options = [
      { id: 'owner', label: t('Owner') },
      { id: 'dweller', label: t('Resident') },
      { id: 'renter', label: t('tenant') },
      { id: 'user', label: t('user') },
      { id: 'family_member', label: t('familyMember') },
      { id: 'child', label: t('child') },
    ];

    const handleChange = (event: any, newValue: any) => {
      if (multiple) {
        setValue(newValue.map((item: any) => item.id) || null);
      } else {
        setValue(newValue?.id || null);
      }
    };

    const getValue = () =>
      multiple
        ? options.filter((item) => value?.indexOf(item.id) > -1)
        : options.find((item) => item.id === value);

    return (
      <FormControl required={required} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <Autocomplete
          value={getValue()}
          options={!options ? [] : options}
          onChange={handleChange}
          slotProps={{
            listbox: {
              component: Listbox,
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              slotProps={{
                input: {
                  ...params.InputProps,
                  required,
                  readOnly,
                  disabled,
                  error: isError,
                },
              }}
            />
          )}
          readOnly={readOnly}
          disabled={disabled}
          multiple={multiple}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
